<template>
<div class="login-footer-links">
  <router-link :to="{name: 'request-password-reset'}">
      <atom-text color="primary" size="x-small" class="mb-0" text="Forgot password?"/>
   </router-link>
   <go-to-link
      question="Don't have an account?"
      label="Create an account"
      routeName="register"
   />
</div>
</template>

<script>
import AtomText from '../../../atoms/Login/Text';
import GoToLink from '../GotoPageLink';

export default {
   name: "footer-links",
   components: { AtomText,GoToLink }
}
</script>

<style lang="scss" scoped>
.login-footer-links {
   text-align: center;
   width: 100%;
   a {
      text-decoration: none;
   }
}
</style>
